<template>
  <div class="main tabs_main">
    <div class="main_header">
      <div class="header_item">
        <span class="header_label">考核名称：</span>
        <el-input v-model="examName" clearable placeholder="请输入考核名称"></el-input>
      </div>
      <div class="header_item">
        <el-button v-if="showButton('search')" icon="el-icon-search" @click="searchSafetyTopicList(true)">查询</el-button>
        <el-button class="search_btn" v-if="showButton('insert')" icon="el-icon-plus" @click="propInsert()">新增</el-button>
      </div>
    </div> 
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="safetyTopicList"
        height="100%">
        <el-table-column label="序号" width="60" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="examName" label="考核名称" width="180" align="center"></el-table-column>
        <el-table-column prop="question" label="问题" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="answers" label="答案" show-overflow-tooltip align="center"></el-table-column>
        <el-table-column prop="score" label="分数" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增考题 修改考题信息 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增安全考题' : '修改安全考题信息'"
      :visible.sync="asyncTopic"
      width="35%">
      <el-form ref="form" :model="formTopic" :rules="rulesTopic" label-width="auto" class="rule_form">
        <el-form-item label="考核名称：" prop="examId">
          <el-select v-model="formTopic.examId" clearable placeholder="请选择考核名称">
            <el-option
              v-for="item in typeNameData"
              :key="item.examId"
              :label="item.examName"
              :value="item.examId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题：" prop="question">
          <el-input 
            type="textarea" 
            v-model="formTopic.question"
            clearable
            placeholder="请输入问题"
            :maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="分数：" prop="score">
          <el-input-number 
            v-model="formTopic.score"
            :controls="false"
            :min="0"
            placeholder="请输入分数">
          </el-input-number>
        </el-form-item>
        <el-form-item label="答案：" prop="answerList">
          <el-table
            :data="formTopic.answerList"
            height="240" 
            :header-cell-style="() => 'background-color: #082F57; color: #18F6F8'">
            <el-table-column label="序号" width="60" align="center">
              <template #default="scope">
                <span>{{scope.$index + 1}}</span>
              </template>
            </el-table-column>
            <el-table-column label="答案" align="center">
              <template #default="{ row }">
                <el-input v-model="row.answer" clearable placeholder="请输入答案"></el-input>
              </template>
            </el-table-column>
            <el-table-column label="是否为正确答案" align="center">
              <template #default="{ row }">
                <el-switch
                  v-model="row.isRight"
                  active-color="#409FFF"
                  inactive-color="#FD494B"
                  active-text="是"
                  :active-value="1"
                  inactive-text="否"
                  :inactive-value="0">
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template #default="{ $index }">
                <el-button class="table_btn" size="mini" v-if="$index + 1 === formTopic.answerList.length" @click="addDataList($index)">新增</el-button>
                <el-button class="delete_btn" size="mini" v-else @click="deleteDataList($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncTopic = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsertForm() : submitUpdateForm()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../../../pinia';
import { throttle } from '../../../../plugins/public';
  export default {
    data() {
      return {
        examName: '',
        loading: false,
        pageNum: 1,
        pageSize: 10,
        total: 0,
        safetyTopicList: [],
        asyncTitle: true, // true 新增  false  修改
        asyncTopic: false, // 弹窗
        formTopic: {}, // 表单信息
        rulesTopic: {
          examId: [{
            required: true,
            message: '请选择考核名称',
            trigger: ['blur', 'change']
          }],
          question: [{
            required: true,
            message: '请输入问题',
            trigger: 'blur'
          }],
          score: [{
            required: true,
            message: '请输入分数',
            trigger: 'blur'
          }],
          answerList: [{
            required: true,
            message: '请填入答案信息',
            trigger: 'blur'
          }],
        }, // 表单校验信息
        typeNameData: [], // 类型名称信息
      }
    },
    mounted() {
      this.searchSafetyTopicList(true);
    },
    methods: {
      // 获取考核名称信息
      async getAllSecureTrainPull() {
        const { data } = await this.$api.Safety.searchSafetyExamineList({
            pageNum: 1,
            pageSize: 1000000,
            examName: '',
            startDay: '',
            endDay: ''
          })
        this.typeNameData = data.list;
      },
      // 查询安全考题信息
      searchSafetyTopicList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.loading = true;
        this.safetyTopicList = [];
        this.$api.Safety.searchSafetyTopicList({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          trainName: this.examName
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.safetyTopicList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 打开添加信息
      propInsert() {
        this.asyncTitle = true;
        this.asyncTopic = true;
        this.$set(this.formTopic, 'answerList', [{
          answer: '',
          isRight: 0
        }]);
      },
      // 打开修改信息
      propUpdate(row) {
        this.$api.Safety.getAnswerlIstInfo({
          queId: row.queId
        }).then((res) => {
          this.$set(this.formTopic, 'answerList', res.data.map(item => {
            return {
              answer: item.answer,
              isRight: item.isRight
            }
          }))
        })
        this.$set(this.formTopic, 'queId', row.queId);
        this.$set(this.formTopic, 'examId', row.examId);
        this.$set(this.formTopic, 'question', row.question);
        this.$set(this.formTopic, 'score', row.score);
        this.asyncTitle = false;
        this.asyncTopic = true;
      },
      // 删除考题信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该考题信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Safety.deleteSafetyTopicInfo({
          queId: row.queId
        }).then(res => {
          if(res.success) {
            this.searchSafetyTopicList(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 新增题目信息
      addDataList(index) {
        this.$set(this.formTopic.answerList, index + 1, {
          answer: '',
          isRight: 0
        });
      }, 
      // 删除题目信息
      deleteDataList(index) {
        this.formTopic.answerList.splice(index, 1);
      },
      // 提交添加信息
      submitInsertForm: throttle(function () {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formTopic);
            this.$api.Safety.insertSafetyTopicInfo(params).then((res) => {
              if(res.success) {
                this.asyncTopic = false;
                this.$message.success('添加成功!');
                this.searchSafetyTopicList(true);
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改信息
      submitUpdateForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formTopic);
            this.$api.Safety.insertSafetyTopicInfo(params).then((res) => {
              if(res.success) {
                this.asyncTopic = false;
                this.$message.success('修改成功!');
                this.searchSafetyTopicList(true);
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 切换页码
      changePageNum(page) {
        this.pageNum = page;
        this.searchSafetyTopicList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchSafetyTopicList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      }
    },
    watch: {
      asyncTopic(bol) {
        if(bol) {
          this.getAllSecureTrainPull();
          this.getAllSecureTrainPull();
        } else {
          this.formTopic = {};
          this.$refs.form.resetFields();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '@/style/layout-main.scss';

::v-deep .el-form-item__content .el-switch {
  padding: 0 !important;
}

::v-deep .el-switch__label {
  color: #FFFFFF;
}

::v-deep .el-switch__label.is-active {
  color: #1890ff;
}
</style>